// extracted by mini-css-extract-plugin
module.exports = {"btn":"ToggleBtn_btn__1Thji","person-btn":"ToggleBtn_person-btn__3pUL8","btn-icon":"ToggleBtn_btn-icon__12dNq"};